const decorator = str => 'preorder/' + str;

export const RESET_PREORDER_INTERVALS = decorator('RESET_PREORDER_INTERVALS');

export const FETCH_PREORDER_INTERVALS = decorator('FETCH_PREORDER_INTERVALS');
export const PREORDER_INTERVALS_LOADED = decorator('PREORDER_INTERVALS_LOADED');
export const PREORDER_INTERVALS_LOADED_WITH_ERROR = decorator('PREORDER_INTERVALS_LOADED_WITH_ERROR');
